import React, { useEffect, useState, useRef, useContext } from "react";
import { LoadingPortContext, resolvePageAccess } from "../../context/LoadingPortContext";
import { AgGridReact } from '@ag-grid-community/react';
import { ClientSideRowModelModule } from '@ag-grid-community/client-side-row-model';
import { RowGroupingModule } from '@ag-grid-enterprise/row-grouping';
import { MenuModule } from '@ag-grid-enterprise/menu';
// import Consignmentforceclose from '../m';
import Select from 'react-select';
import { AllModules, GridOptionsWrapper } from '@ag-grid-enterprise/all-modules';
import { ColumnsToolPanelModule } from '@ag-grid-enterprise/column-tool-panel';
import { FiltersToolPanelModule } from '@ag-grid-enterprise/filter-tool-panel';
import { SetFilterModule } from '@ag-grid-enterprise/set-filter';
import '@ag-grid-community/core/dist/styles/ag-grid.css';
import "@ag-grid-enterprise/all-modules/dist/styles/ag-theme-balham.css";
import { Edit, Trash } from "lucide-react";
import SweetAlert from 'react-bootstrap-sweetalert';
var redirectURL = require('../redirectURL');

const styles = `
  .acc-pill     { display: inline-block; border-radius: 20px; padding: 3px 10px; font-size: 12px; font-weight: 500; }
  .acc-pill-yes { background: #e7f7ef; color: #1a8a4a; }
  .acc-pill-no  { background: #fdecea; color: #c0392b; }
`;

var fieldStyle = {
    width: "100%", padding: "9px 12px", border: "1.5px solid #dde2ea", borderRadius: "8px",
    fontSize: "13.5px", color: "#1a1d23", background: "#fafbfc", outline: "none"
};
var fieldStyleLocked = Object.assign({}, fieldStyle, { background: "#f4f6f9", color: "#9aa1ae", cursor: "not-allowed", borderColor: "#e4e8ef" });

var AirCourierConfig = function () {

    var portContext = useContext(LoadingPortContext);
    var lastPortRef = useRef(portContext.loading_port_code);

    var orderTypeState = useState("");
    var orderType = orderTypeState[0];
    var setOrderType = orderTypeState[1];

    var orderTypePlanningState = useState(1);
    var orderTypePlanning = orderTypePlanningState[0];
    var setOrderTypePlanning = orderTypePlanningState[1];

    var editingOrderTypeState = useState(null);
    var editingOrderType = editingOrderTypeState[0];
    var setEditingOrderType = editingOrderTypeState[1];

    var originalOrderTypeState = useState(null);
    var originalOrderType = originalOrderTypeState[0];
    var setOriginalOrderType = originalOrderTypeState[1];

    var orderTypeListState = useState([]);
    var orderTypeList = orderTypeListState[0];
    var setOrderTypeList = orderTypeListState[1];

    var floorState = useState("");
    var floor = floorState[0];
    var setFloor = floorState[1];

    var floorPlanningState = useState(1);
    var floorPlanning = floorPlanningState[0];
    var setFloorPlanning = floorPlanningState[1];

    var editingFloorState = useState(null);
    var editingFloor = editingFloorState[0];
    var setEditingFloor = editingFloorState[1];

    var originalFloorState = useState(null);
    var originalFloor = originalFloorState[0];
    var setOriginalFloor = originalFloorState[1];

    var floorListState = useState([]);
    var floorList = floorListState[0];
    var setFloorList = floorListState[1];

    var loadingState = useState(false);
    var loading = loadingState[0];
    var setLoading = loadingState[1];

    const [show, setShow] = useState(false);
    const [basicType, setBasicType] = useState("");
    const [basicTitle, setBasicTitle] = useState("");
    const closeAlert = () => setShow(false);

    var categoryStatusState = useState({ od_category: "NO", h_category: "NO" });
    var categoryStatus = categoryStatusState[0];

    const [pageAccess, setPageAccess] = useState("");
        const [loadingPortCode, setLoadingPortCode] = useState("");
        const [compCode, setCompCode] = useState("");
        const [lpNames, setLpNames] = useState([]);
        const [loadingPortData, setLoadingPortData] = useState([])
    const codeRef = useRef(null);
    useEffect(() => {
        const fetchData = async () => {
            // setLoadshow("show-m")
            // setOverly("show-m")
            var code = await pageAccessFn();
            
            console.log(code, "hello")
            await getNecessaryData(code);
            // setLoadshow("show-n")
            // setOverly("show-n")
        }
        fetchData();
    }, []);
    const getNecessaryData = async (code) => {
        codeRef.current = code;
        await getOrderTypes(code);
        await getFloors(code);
    }

    // React to the loading port changing from the header's global selector.
    useEffect(() => {
        if (portContext.loading_port_code !== lastPortRef.current) {
            lastPortRef.current = portContext.loading_port_code;
            onGlobalPortChange(portContext.loading_port_code);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [portContext.loading_port_code]);

    const onGlobalPortChange = async (selectedPlant) => {
        if (!selectedPlant || !loadingPortData.some((each) => each.value == selectedPlant)) {
            // Not a valid port for this screen - keep this screen's own selection.
            return;
        }
        setLoadingPortCode(selectedPlant);
        await getNecessaryData(selectedPlant);
    };

    var showAlert = function (message, type) {
        setShow(true);
        setBasicType(type === "error" ? "warning" : (type || "success"));
        setBasicTitle(message);
    };

    var getOrderTypes = function (code) {
        redirectURL.post("/lmconsignees/getAirCourierOrderTypes", { loading_port_code: code, status: 1 })
            .then(function (res) { setOrderTypeList(res.data.data || []); })
            .catch(function (err) { console.log(err); });
    };

    var getFloors = function (code) {
        redirectURL.post("/lmconsignees/getAirCourierFloors", { loading_port_code: code, status: 1 })
            .then(function (res) { setFloorList(res.data.data || []); })
            .catch(function (err) { console.log(err); });
    };

    /* ── ORDER TYPE ── */
    var saveOrderType = function () {
        if (!orderType.trim()) { showAlert("Please enter an Order Type", "warning"); return; }
        var isEdit = editingOrderType !== null;
        if (isEdit && originalOrderType &&
            String(orderType) === String(originalOrderType.order_type) &&
            String(orderTypePlanning) === String(originalOrderType.allow_air_courier_planning)) {
            showAlert("No changes found. Please modify at least one field before updating.", "warning");
            return;
        }
        setLoading(true);
        redirectURL.post("/lmconsignees/saveAirCourierOrderType", {
            order_type: orderType, loading_port_code: loadingPortCode,
            allow_air_courier_planning: Number(orderTypePlanning),
            status: 1,
            created_by: localStorage.getItem("email"),
            updated_on: new Date()
        })
            .then(function (res) {
                if (res.data.status === "success") {
                    showAlert(
                        res.data.message || (isEdit ? "Updated Successfully." : "Added Successfully."),
                        "success"
                    );
                    resetOrderTypeForm();
                    getOrderTypes(loadingPortCode);
                } else {
                    showAlert(res.data.message || (isEdit ? "Failed to update." : "Failed to Add."), "error");
                }
                setLoading(false);
            })
            .catch(function (err) {
                console.log(err);
                var msg = err && err.response && err.response.data && err.response.data.message
                    ? err.response.data.message : (isEdit ? "Failed to update." : "Failed to Add.");
                showAlert(msg, "error");
                setLoading(false);
            });
    };

    var startEditOrderType = function (record) {
        setEditingOrderType(record);
        setOriginalOrderType(record);
        setOrderType(record.order_type);
        setOrderTypePlanning(record.allow_air_courier_planning);
    };

    var resetOrderTypeForm = function () {
        setOrderType(""); setOrderTypePlanning(1); setEditingOrderType(null); setOriginalOrderType(null);
    };

    var deleteOrderType = function (records, type) {
        if (!window.confirm("Are you sure to delete this record?")) return;
        setLoading(true);
        redirectURL.post("/lmconsignees/deleteAirCourierOrderType", { records })
            .then(function (res) {
                if (res.data.status === "success") {
                    showAlert(res.data.message || "Deleted Successfully.", "success");
                    setOrderDelRec([]);
                    getOrderTypes(codeRef.current);
                } else {
                    showAlert(res.data.message || "Failed to Delete.", "error");
                }
                setLoading(false);
            })
            .catch(function (err) {
                console.log(err);
                var msg = err && err.response && err.response.data && err.response.data.message
                    ? err.response.data.message : "Failed to Delete.";
                showAlert(msg, "error");
                setLoading(false);
            });
    };

    /* ── FLOOR ── */
    var saveFloor = function () {
        if (!floor.trim()) { showAlert("Please enter a Floor", "warning"); return; }
        var isEdit = editingFloor !== null;
        if (isEdit && originalFloor &&
            String(floor) === String(originalFloor.floor) &&
            String(floorPlanning) === String(originalFloor.allow_air_courier_planning)) {
            showAlert("No changes found. Please modify at least one field before updating.", "warning");
            return;
        }
        setLoading(true);
        redirectURL.post("/lmconsignees/saveAirCourierFloor", {
            floor: floor, loading_port_code: loadingPortCode,
            allow_air_courier_planning: Number(floorPlanning),
            status: 1,
            created_by: localStorage.getItem("email"),
            updated_on: new Date()
        })
            .then(function (res) {
                if (res.data.status === "success") {
                    showAlert(
                        res.data.message || (isEdit ? "Updated Successfully." : "Added Successfully."),
                        "success"
                    );
                    resetFloorForm();
                    getFloors(loadingPortCode);
                } else {
                    showAlert(res.data.message || (isEdit ? "Failed to update." : "Failed to Add."), "error");
                }
                setLoading(false);
            })
            .catch(function (err) {
                console.log(err);
                var msg = err && err.response && err.response.data && err.response.data.message
                    ? err.response.data.message : (isEdit ? "Failed to update." : "Failed to Add.");
                showAlert(msg, "error");
                setLoading(false);
            });
    };

    var startEditFloor = function (record) {
        setEditingFloor(record);
        setOriginalFloor(record);
        setFloor(record.floor);
        setFloorPlanning(record.allow_air_courier_planning);
    };

    var resetFloorForm = function () {
        setFloor(""); setFloorPlanning(1); setEditingFloor(null); setOriginalFloor(null);
    };

    var deleteFloor = function (records, type) {
        if (!window.confirm("Are you sure to delete this record?")) return;
        setLoading(true);
        redirectURL.post("/lmconsignees/deleteAirCourierFloor", { records })
            .then(function (res) {
                if (res.data.status === "success") {
                    showAlert(res.data.message || "Deleted Successfully.", "success");
                    setFloorDelRec([]);
                    getFloors(codeRef.current);
                } else {
                    showAlert(res.data.message || "Failed to Delete.", "error");
                }
                setLoading(false);
            })
            .catch(function (err) {
                console.log(err);
                var msg = err && err.response && err.response.data && err.response.data.message
                    ? err.response.data.message : "Failed to Delete.";
                showAlert(msg, "error");
                setLoading(false);
            });
    };

    var anyEditing = editingOrderType !== null || editingFloor !== null;

    var cancelAllEditing = function () {
        resetOrderTypeForm();
        resetFloorForm();
    };

    const ActionRenderer = (props) => (
        <div className="d-flex justify-content-center align-items-center" style={{ gap: '6px', justifyContent: "center", width: "100%", height: "35px" }}>

            <Edit className="text-primary cursor-pointer ml-2 d-none"
                size={15} style={{ cursor: "pointer" }} onClick={() => { startEditOrderType(props.data) }} />
            <Trash className="text-danger cursor-pointer ml-2"
                size={19} style={{ cursor: "pointer" }} onClick={() => { deleteOrderType([props.data._id]) }} />
        </div>
    );

    const FloorActionRenderer = (props) => (
        <div className="d-flex justify-content-center align-items-center" style={{ gap: '6px', justifyContent: "center", width: "100%", height: "35px" }}>

            <Edit className="text-primary cursor-pointer ml-2 d-none"
                size={15} style={{ cursor: "pointer" }} onClick={() => { startEditFloor(props.data) }} />
            <Trash className="text-danger cursor-pointer ml-2"
                size={19} style={{ cursor: "pointer" }} onClick={() => { deleteFloor([props.data._id]) }} />
        </div>
    );
    // ---------------- GRID ----------------
    const components = {
        actionRenderer: ActionRenderer,
        floorActionRenderer: FloorActionRenderer
    };
    const columnDefs = [

        {
            headerName: "",
            width: 90,
            cellRenderer: "actionRenderer",
            pinned: "left",
            headerCheckboxSelection: true,
            headerCheckboxSelectionFilteredOnly: true,
            checkboxSelection: true
        },
        // { headerName: "Source", field: "comp_short_name", flex: 1 },
        { headerName: "Order Type", field: "order_type", width: 190, flex: 1 },
        {
            headerName: "Allow Planning", width: 190,
            cellRendererFramework: (params) => {
                return <span className={"acc-pill " + (params.data.allow_air_courier_planning === 1 ? "acc-pill-yes" : "acc-pill-no")}>
                    {params.data.allow_air_courier_planning === 1 ? "Yes" : "No"}
                </span>
            }, flex: 1
        }
    ]
    const floorColumnDefs = [

        {
            headerName: "",
            width: 90,
            cellRenderer: "floorActionRenderer",
            pinned: "left",
            headerCheckboxSelection: true,
            headerCheckboxSelectionFilteredOnly: true,
            checkboxSelection: true
        },
        // { headerName: "Source", field: "comp_short_name", flex: 1 },
        { headerName: "Floor", field: "floor", width: 190, flex: 1 },
        {
            headerName: "Allow Planning", width: 190,
            cellRendererFramework: (params) => {
                return <span className={"acc-pill " + (params.data.allow_air_courier_planning === 1 ? "acc-pill-yes" : "acc-pill-no")}>
                    {params.data.allow_air_courier_planning === 1 ? "Yes" : "No"}
                </span>
            }, flex: 1
        }
    ]

    const pageAccessFn = async () => {

        const currentUrl = window.location.pathname;

        try {
            const resolved = await resolvePageAccess(currentUrl, portContext);
            if (!resolved) {
                // No access (already alerted+redirected), empty port list, or a logged request error.
                return;
            }
            lastPortRef.current = resolved.loading_port_code;
            setPageAccess(resolved.pageAccess);
            setLoadingPortCode(resolved.loading_port_code);
            setCompCode(resolved.comp_code);
            setLoadingPortData(resolved.lpNames);
            return resolved.loading_port_code;
        } catch (err) {
            console.log(err);
        }

    };
    const [orderDelRec, setOrderDelRec] = useState([]);
    const [floorDelRec, setFloorDelRec] = useState([]);
    const orderGridRef = useRef(null);
    const floorGridRef = useRef(null);
    /* ── RENDER ── */
    return (
        <div className="card col-xl-12" style={{ borderRadius: "10px", boxShadow: "0 1px 4px rgba(0,0,0,0.08)", minHeight: "100%", display: "flex", flexDirection: "column" }}>
            <style>{styles}</style>

            <SweetAlert
                show={show}
                type={basicType}
                title={basicTitle}
                onConfirm={closeAlert}
                styles={{ zIndex: "10000001" }}
            >
            </SweetAlert>

            <div className="d-flex justify-content-between align-items-center" style={{ flexWrap: "wrap", gap: "10px", padding: "14px 18px", marginBottom: "10px", flexShrink: 0 }}>
                <div className="d-flex align-items-center" style={{ gap: "14px" }}>
                    <div style={{ width: "5px", height: "26px", background: "linear-gradient(180deg,#1976d2,#42a5f5)", borderRadius: "3px", flexShrink: 0 }}></div>
                    <h5 style={{ margin: 0, fontSize: "16px", fontWeight: 700, color: "#1a237e", letterSpacing: "0.2px" }}>Air Courier Configuration</h5>
                </div>

                <div className="d-flex align-items-center" style={{ flexWrap: "wrap", gap: "10px" }}>
                    {[
                        { label: "OD Category (Over Dimension)", value: categoryStatus.od_category },
                        { label: "H Category (Hazardous)", value: categoryStatus.h_category },
                    ].map(function (item) {
                        var isYes = String(item.value).toUpperCase() === "YES";
                        return (
                            <div
                                key={item.label}
                                className="d-flex align-items-center"
                                style={{
                                    gap: "8px", padding: "6px 14px", borderRadius: "999px",
                                    background: isYes ? "#ecfdf5" : "#fef2f2",
                                    border: "1px solid " + (isYes ? "#bbf7d0" : "#fecaca")
                                }}
                            >
                                <span style={{ fontSize: "12px", fontWeight: 600, color: isYes ? "#166534" : "#7f1d1d", whiteSpace: "nowrap" }}>
                                    {item.label}
                                </span>
                                <span style={{ fontSize: "13px", fontWeight: 700, color: isYes ? "#15803d" : "#dc2626" }}>
                                    {item.value}
                                </span>
                            </div>
                        );
                    })}
                </div>
                </div>

                <div className="d-flex" style={{ gap: "20px", flexWrap: "wrap", alignItems: "flex-start", padding: "0 18px 18px" }}>

                    {/* ── ORDER TYPE CARD ── */}
                    <div style={{ background: "#fff", border: "1px solid " + (editingOrderType ? "#fde8a0" : "#e4e8ef"), borderRadius: "10px", padding: "20px", flex: 1, minWidth: "340px", boxShadow: "0 1px 4px rgba(0,0,0,0.05)" }}>
                        <div className="d-flex justify-content-between align-items-start">
                            <div>
                                <div style={{ fontSize: "14px", fontWeight: 700, color: "#1a237e", display: "flex", alignItems: "center", gap: "8px" }}>
                                    Order Type Config
                                    <span style={{ fontSize: "10.5px", fontWeight: 500, borderRadius: "20px", padding: "2px 8px", background: editingOrderType ? "#fff8e1" : "#eef1ff", color: editingOrderType ? "#b8860b" : "#1976d2" }}>
                                        {editingOrderType ? "Editing" : "New Entry"}
                                    </span>
                                </div>
                                <p style={{ fontSize: "12.5px", color: "#78828f", margin: "4px 0 18px" }}>
                                    {editingOrderType
                                        ? 'Editing: "' + editingOrderType.order_type + '" — only Allow Planning can be changed'
                                        : "Add a new order type for air courier routing"}
                                </p>
                            </div>
                            {editingOrderType && (
                                <button className="pill-btn" style={{ background: "#fff8e1", color: "#b8860b", fontSize: "12px", padding: "6px 12px" }} onClick={cancelAllEditing}>
                                    ✕ Cancel Editing
                                </button>
                            )}
                        </div>

                        <div className="d-flex align-items-end" style={{ gap: "12px", flexWrap: "wrap", marginTop: "6px" }}>
                            <div style={{ flex: 1, minWidth: "120px" }}>
                                <label style={{ display: "block", fontSize: "12px", fontWeight: 500, color: "#5a6270", marginBottom: "6px" }}>Order Type</label>
                                <input
                                    type="text"
                                    placeholder="Enter"
                                    value={orderType}
                                    readOnly={editingOrderType !== null}
                                    onChange={function (e) {
                                        if (!editingOrderType) { setOrderType(e.target.value); }
                                    }}
                                    style={editingOrderType ? fieldStyleLocked : fieldStyle}
                                />
                            </div>
                            <div style={{ flex: 1, minWidth: "120px" }}>
                                <label style={{ display: "block", fontSize: "12px", fontWeight: 500, color: "#5a6270", marginBottom: "6px" }}>Allow Planning</label>
                                <select
                                    value={orderTypePlanning}
                                    onChange={function (e) { setOrderTypePlanning(e.target.value); }}
                                    disabled
                                    style={fieldStyleLocked}
                                >
                                    <option value={1}>Yes</option>
                                    <option value={0}>No</option>
                                </select>
                            </div>
                            <button
                                className={"pill-btn " + (editingOrderType ? "pill-btn-warning" : "pill-btn-success")}
                                onClick={saveOrderType}
                                disabled={loading}
                            >
                                {loading ? "Saving…" : editingOrderType ? "Update Order Type" : "Add Order Type"}
                            </button>
                        </div>

                        <div style={{ height: "1px", background: "#e8ecf2", margin: "20px 0" }} />

                        <div className="d-flex justify-content-between align-items-center" style={{ marginBottom: "12px" }}>
                            <span style={{ fontSize: "14px", fontWeight: 600, color: "#1a237e" }}>Saved Order Types</span>
                            <div className="d-flex align-items-center" style={{ gap: "10px" }}>
                              {orderDelRec.length > 0 && <button className="pill-btn pill-btn-danger" onClick={() => {
                                deleteOrderType(orderDelRec, true)
                              }}>Bulk Delete</button>}
                              <span style={{ fontSize: "12px", fontWeight: 500, color: "#78828f", background: "#f2f4f8", borderRadius: "20px", padding: "3px 10px" }}>{orderTypeList.length} records</span>
                            </div>
                        </div>
                        <div>
                            <div className="ag-theme-balham grid-wrapper" style={{ height: "310px" }}>
                                <AgGridReact
                                    ref={orderGridRef}
                                    modules={AllModules}
                                    rowData={orderTypeList}
                                    columnDefs={columnDefs}
                                    defaultColDef={{
                                        sortable: true,
                                        filter: true,
                                        floatingFilter: true, resizable: true
                                    }}
                                    statusBar={{
                                        statusPanels: [
                                            { statusPanel: "agTotalRowCountComponent", align: "right" }
                                        ]
                                    }}
                                    animateRows
                                    rowSelection={"multiple"}
                                    rowHeight={45}
                                    headerHeight={45}
                                    frameworkComponents={components}
                                    onSelectionChanged={() => {
                                        if (orderGridRef && orderGridRef.current && orderGridRef.current.api) {
                                            const selected = orderGridRef.current.api.getSelectedRows();
                                            // this.setState({ selectedRows: selected })
                                            setOrderDelRec(selected.map((each) => each._id))
                                        }
                                    }} 
                                    suppressRowClickSelection={true}
                                />
                            </div>
                        </div>
                    </div>

                    {/* ── FLOOR CARD ── */}
                    <div style={{ background: "#fff", border: "1px solid " + (editingFloor ? "#fde8a0" : "#e4e8ef"), borderRadius: "10px", padding: "20px", flex: 1, minWidth: "340px", boxShadow: "0 1px 4px rgba(0,0,0,0.05)" }}>
                        <div className="d-flex justify-content-between align-items-start">
                            <div>
                                <div style={{ fontSize: "14px", fontWeight: 700, color: "#1a237e", display: "flex", alignItems: "center", gap: "8px" }}>
                                    Floor Config
                                    <span style={{ fontSize: "10.5px", fontWeight: 500, borderRadius: "20px", padding: "2px 8px", background: editingFloor ? "#fff8e1" : "#eef1ff", color: editingFloor ? "#b8860b" : "#1976d2" }}>
                                        {editingFloor ? "Editing" : "New Entry"}
                                    </span>
                                </div>
                                <p style={{ fontSize: "12.5px", color: "#78828f", margin: "4px 0 18px" }}>
                                    {editingFloor
                                        ? 'Editing: "' + editingFloor.floor + '" — only Allow Planning can be changed'
                                        : "Register a new floor for air courier dispatch"}
                                </p>
                            </div>
                            {editingFloor && (
                                <button className="pill-btn" style={{ background: "#fff8e1", color: "#b8860b", fontSize: "12px", padding: "6px 12px" }} onClick={cancelAllEditing}>
                                    ✕ Cancel Editing
                                </button>
                            )}
                        </div>
                        <div className="d-flex align-items-end" style={{ gap: "12px", flexWrap: "wrap", marginTop: "6px" }}>
                            <div style={{ flex: 1, minWidth: "120px" }}>
                                <label style={{ display: "block", fontSize: "12px", fontWeight: 500, color: "#5a6270", marginBottom: "6px" }}>Floor</label>
                                <input
                                    type="text"
                                    placeholder="Enter"
                                    value={floor}
                                    readOnly={editingFloor !== null}
                                    onChange={function (e) {
                                        if (!editingFloor) { setFloor(e.target.value); }
                                    }}
                                    style={editingFloor ? fieldStyleLocked : fieldStyle}
                                />
                            </div>
                            <div style={{ flex: 1, minWidth: "120px" }}>
                                <label style={{ display: "block", fontSize: "12px", fontWeight: 500, color: "#5a6270", marginBottom: "6px" }}>Allow Planning</label>
                                <select
                                    value={floorPlanning}
                                    onChange={function (e) { setFloorPlanning(e.target.value); }}
                                    disabled
                                    style={fieldStyleLocked}
                                >
                                    <option value={1}>Yes</option>
                                    <option value={0}>No</option>
                                </select>
                            </div>
                            <button
                                className={"pill-btn " + (editingFloor ? "pill-btn-warning" : "pill-btn-success")}
                                onClick={saveFloor}
                                disabled={loading}
                            >
                                {loading ? "Saving…" : editingFloor ? "Update Floor" : "Add Floor"}
                            </button>
                        </div>

                        <div style={{ height: "1px", background: "#e8ecf2", margin: "20px 0" }} />

                        <div className="d-flex justify-content-between align-items-center" style={{ marginBottom: "12px" }}>
                            <span style={{ fontSize: "14px", fontWeight: 600, color: "#1a237e" }}>Saved Floors</span>
                            <div className="d-flex align-items-center" style={{ gap: "10px" }}>
                              {floorDelRec.length > 0 && <button className="pill-btn pill-btn-danger" onClick={() => {
                                deleteFloor(floorDelRec, true)
                              }}>Bulk Delete</button>}
                            <span style={{ fontSize: "12px", fontWeight: 500, color: "#78828f", background: "#f2f4f8", borderRadius: "20px", padding: "3px 10px" }}>{floorList.length} records</span>
                            </div>
                        </div>
                        <div>
                            <div className="ag-theme-balham grid-wrapper" style={{ height: "310px" }}>
                                <AgGridReact
                                    ref={floorGridRef}
                                    modules={AllModules}
                                    rowData={floorList}
                                    columnDefs={floorColumnDefs}
                                    defaultColDef={{
                                        sortable: true,
                                        filter: true,
                                        floatingFilter: true, resizable: true
                                    }}
                                    statusBar={{
                                        statusPanels: [
                                            { statusPanel: "agTotalRowCountComponent", align: "right" }
                                        ]
                                    }}
                                    animateRows
                                    // rowSelection={"multiple"}
                                    rowHeight={45}
                                    headerHeight={45}
                                    frameworkComponents={components}
                                    onSelectionChanged={() => {
                                        if (floorGridRef && floorGridRef.current && floorGridRef.current.api) {
                                            const selected = floorGridRef.current.api.getSelectedRows();
                                            // this.setState({ selectedRows: selected })
                                            setFloorDelRec(selected.map((each) => each._id))
                                        }
                                    }} 
                                    suppressRowClickSelection={true}
                                />
                            </div>
                        </div>
                    </div>

                </div>
        </div>
    );
};

export default AirCourierConfig;